import React, { useContext } from 'react';
import { QueryContext } from '../../../hooks/Contexts';
import Icon from '../../common/Icon';

const Ellipses = () => (
  <li>
    <span>&hellip;</span>
  </li>
);

const PaginateControls = ({ totalPages }) => {
  const { queryParams, setQueryParams } = useContext(QueryContext);
  const perPage = queryParams.per_page || '25';
  const currentPage = Number(queryParams.page);
  const showLeftArrow = currentPage > 1;
  const showRightArrow = currentPage < totalPages;
  const firstPageVisible = currentPage - 4 <= 1;
  const lastPageVisible = currentPage + 4 >= totalPages;
  const showFirstEllipsis = currentPage - 4 >= 4;
  const showLastEllipsis = currentPage + 4 < totalPages - 2;
  const nextPage = currentPage + 1;
  const previousPage = currentPage - 1;
  const lastPages = () => {
    let tempPages = [];
    let lastShown = currentPage + 4;
    if (lastShown < totalPages - 1) tempPages.push(totalPages - 1);
    if (lastShown < totalPages) tempPages.push(totalPages);
    return tempPages;
  };
  const firstPages = () => {
    let tempPages = [];
    let firstShown = currentPage - 4;
    if (firstShown > 1) tempPages.push(1);
    if (firstShown > 2) tempPages.push(2);
    return tempPages;
  };
  const closePages = () => {
    let i,
      len,
      pages = [];
    for (i = currentPage - 1, len = 0; i >= 1 && len < 4; i--, len++) {
      pages.unshift(i);
    }
    pages.push(currentPage);
    for (i = currentPage + 1, len = 0; i <= totalPages && len < 4; i++, len++) {
      pages.push(i);
    }
    return pages;
  };

  const PageNumber = ({ page }) => {
    const activeStatus = currentPage === page ? 'active' : '';
    return (
      <li
        onClick={() => {
          if (currentPage === page) return;
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
          setQueryParams((params) => {
            return { ...params, page: page.toString() };
          });
        }}
      >
        <a className={activeStatus}>{page}</a>
      </li>
    );
  };

  const PerPage = ({ option }) => {
    const activeStatus = perPage === option ? 'active' : '';
    return (
      <a
        className={activeStatus}
        onClick={() => {
          if (activeStatus === 'active') return;
          setQueryParams((params) => {
            return {
              ...params,
              per_page: option,
              page: '1',
            };
          });
        }}
      >
        {option}
      </a>
    );
  };

  return (
    <>
      <ol className='paginate-controls'>
        {showLeftArrow && (
          <li>
            <Icon
              icon='chevron-left'
              title='Previous page'
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                setQueryParams((params) => {
                  return { ...params, page: previousPage };
                });
              }}
            />
          </li>
        )}

        {!firstPageVisible && (
          <>
            {firstPages().map((page) => {
              return <PageNumber key={page} page={page} />;
            })}
            {showFirstEllipsis && <Ellipses />}
          </>
        )}

        {closePages().map((page) => {
          return <PageNumber key={page} page={page} />;
        })}

        {!lastPageVisible && (
          <>
            {showLastEllipsis && <Ellipses />}
            {lastPages().map((page) => {
              return <PageNumber key={page} page={page} />;
            })}
          </>
        )}

        {showRightArrow && (
          <li>
            <Icon
              icon='chevron-right'
              title='Next page'
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                setQueryParams((params) => {
                  return { ...params, page: nextPage };
                });
              }}
            />
          </li>
        )}
      </ol>

      <div>
        <ol className='paginate-controls'>
          <span style={{ marginRight: '12px' }}>Submissions Per Page</span>
          <PerPage option='25' />
          {' | '}
          <PerPage option='50' />
        </ol>
      </div>
    </>
  );
};

export default PaginateControls;
